import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
import NumberFormat from 'react-number-format';

export default class ChequeInfo extends Base {
	constructor(props) {
		super(props);
		this.state = {
			caller: props.Caller,
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			type: props.Type,
			data: null,
			loading: true,
		};
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();
		this.httpPost("api/v1/cheque/get", {
			id: this.state.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					if (data.record.id === this.getDefaultGuid()) data.record.firstAnnual = true;
					this.setState({
						data: data,
						loading: false
					});
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	save() {
		if (this.isBlank(this.state.data.record.price)) this.state.data.record.price = 0;
		this.httpPost("api/v1/cheque/save", {
			id: this.state.data.record.id,
			organizationId: this.state.data.global.company.id,
			type: this.state.type,
			chequeDate: this.convertMomentToDb(this.state.data.record.chequeDate),
			description: this.state.data.record.description,
			sayyadi: this.state.data.record.sayyadi,
			branch: this.state.data.record.branch,
			bankId: this.state.data.record.bankId,
			fromPersonId: this.state.data.record.fromPersonId,
			chequeId: this.state.data.record.chequeId,
			toPersonId: this.state.data.record.toPersonId,
			number: this.state.data.record.number,
			guarantee: this.state.data.record.guarantee,
			price: this.state.data.record.price,
			status: this.state.data.record.status,
			firstAnnual: this.state.data.record.firstAnnual,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
					this.state.caller.refreshData();
					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	renderForm() {
		return <div className="modal fade in show" tabindex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }}></div>
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<button type="button" className="close" onClick={e => this.closeMe()} ><span aria-hidden="true">×</span></button>
						<h4 className="modal-title" id="chequeReturnModalLabel">
							{this.state.id === this.getDefaultGuid() && <span>ثبت چک</span>}
							{this.state.id !== this.getDefaultGuid() && <span>ویرایش چک</span>}
						</h4>
					</div>
					<div className="modal-body">
						<div className="container-fluid">
							<div className="row mr-t-5">
								<div className="col-sm-3  text-left">تاریخ <span className="red">*</span> :</div>
								<div className="col-sm-9">
									<DatePicker
										inputReadOnly={true}
										className="form-control input-sm persian-date"
										placeholder={"تاریخ"}
										isGregorian={false}
										showTodayButton={true}
										timePicker={false}
										onChange={(e) => { this.state.data.record.chequeDate = e }}
										value={this.getFormatedDateForDatePicker(this.state.data.record.chequeDate)}
									/>
								</div>
							</div>
							{this.state.type === 1 && <div className="row mr-t-5">
								<div className="col-sm-3 text-left">شماره <span className="red">*</span> :</div>
								<div className="col-sm-9">
									<input defaultValue={this.state.data.record.number} onChange={e => this.state.data.record.number = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm ng-valid" />
								</div>
							</div>}
							{this.state.type === 2 && <div className="row mr-t-5">
								<div className="col-sm-3 text-left">بانک <span className="red">*</span> :</div>
								<div className="col-sm-9">
									<SelectAsync
										value={
											this.state.data.record.bankAccountId !== this.defaultGuid()
												? {
													value: this.state.data.record.bankAccountId,
													label: this.state.data.record.bankAccountName,
												}
												: null
										}
										isMulti={false}
										placeholder="انتخاب بانک"
										defaultOptions
										loadOptions={this.loadBankAccountsOptions}
										onChange={(e) => {
											this.state.data.record.bankAccountId = e.value;
											this.state.data.record.bankAccountName = e.label;
										}}
									/>
								</div>
							</div>}
							{this.state.type === 2 && <div className="row mr-t-5">
								<div className="col-sm-3 text-left">شماره <span className="red">*</span> :</div>
								<div className="col-sm-9">
									<SelectAsync
										defaultValue={this.state.data.record.number > 0 ? [{ value: this.state.data.record.chequeId, label: this.state.data.record.number }] : null}
										isMulti={false}
										placeholder="انتخاب چک"
										defaultOptions
										loadOptions={(inputValue, callback) => this.loadChequeNumbersOptions(inputValue, callback, this.state.data.record.bankAccountId)}
										onChange={e => {
											this.state.data.record.chequeId = e.value;
											this.state.data.record.number = e.number;
										}
										}
									/>
								</div>
							</div>}
							<div className="row mr-t-5">
								<div className="col-sm-3 text-left">مبلغ <span className="red">*</span> :</div>
								<div className="col-sm-9">
									<NumberFormat
										value={this.state.data.record.price}
										onChange={(e) => this.state.data.record.price = parseInt(e.target.value.replace(/,/g, ''))}
										thousandSeparator={true}
										prefix={''}
										className="form-control ltr"
									/>
								</div>
							</div>
							{this.state.type === 1 && <div className="row mr-t-5">
								<div className="col-sm-3 text-left">بانک <span className="red">*</span> :</div>
								<div className="col-sm-9">
									<SelectAsync
										style={{ "width": "100%" }}
										defaultValue={this.state.data.record.bankId !== this.getDefaultGuid() ? [{ value: this.state.data.record.bankId, label: this.state.data.record.bankName }] : null}
										isMulti={false}
										placeholder="جستجو و انتخاب بانک"
										noOptionsMessage={({ inputValue }) =>
											inputValue ? "نتیجه‌ای یافت نشد" : null
										}
										//defaultOptions={[]}
										components={{
											// DropdownIndicator: () => null,
											IndicatorSeparator: () => null,
										}}
										loadOptions={(inputValue, callback) => this.loadBanksOptions(inputValue, callback)}
										onChange={e => {
											this.state.data.record.bankId = e.value;
											this.state.data.record.bankName = e.label;
										}}
									/>
								</div>
							</div>}
							{this.state.type === 1 && <div className="row mr-t-5">
								<div className="col-sm-3 text-left">شعبه <span className="red">*</span> :</div>
								<div className="col-sm-9">
									<input defaultValue={this.state.data.record.branch} onChange={e => this.state.data.record.branch = e.target.value} autocomplete="off" type="text" className="form-control input-sm ng-valid" />
								</div>
							</div>}
							<div className="row mr-t-5">
								<div className="col-sm-3 text-left">شماره صیادی <span className="red">*</span> :</div>
								<div className="col-sm-9">
									<input defaultValue={this.state.data.record.sayyadi} onChange={e => this.state.data.record.sayyadi = e.target.value} autocomplete="off" type="text" className="form-control input-sm ng-valid" />
								</div>
							</div>
							<div className="row mr-t-5">
								<div className="col-sm-3 text-left">توضیحات <span className="red">*</span> :</div>
								<div className="col-sm-9">
									<input defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} autocomplete="off" type="text" className="form-control input-sm ng-valid" />
								</div>
							</div>
							{this.state.type === 1 && <div className="row mr-t-5">
								<div className="col-sm-3 text-left">شخص <span className="red">*</span> :</div>
								<div className="col-sm-9">
									<SelectAsync
										isMulti={false}
										placeholder="انتخاب شخص"
										defaultOptions
										defaultValue={this.state.data.record.fromPersonId === this.getDefaultGuid() ? null : { value: this.state.data.record.fromPersonId, label: this.state.data.record.fromPersonName }}
										loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 0)}
										onChange={e => {
											this.state.data.record.fromPersonId = e.value;
											this.state.data.record.fromPersonName = e.label;
										}}
									/>
								</div>
							</div>}
							{this.state.type === 2 && <div className="row mr-t-5">
								<div className="col-sm-3 text-left">شخص <span className="red">*</span> :</div>
								<div className="col-sm-9">
									<SelectAsync
										isMulti={false}
										placeholder="انتخاب شخص"
										defaultOptions
										defaultValue={this.state.data.record.toPersonId === this.getDefaultGuid() ? null : { value: this.state.data.record.toPersonId, label: this.state.data.record.toPersonName }}
										loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 0)}
										onChange={e => {
											this.state.data.record.toPersonId = e.value;
											this.state.data.record.toPersonName = e.label;
										}}
									/>
								</div>
							</div>}
							{this.state.type === 1 && <div className="row mr-t-5">
								<div className="col-sm-3 text-left">وضعیت <span className="red">*</span> :</div>
								<div className="col-sm-9">
									<select defaultValue={this.state.data.record.status} onChange={e => this.state.data.record.status = e.target.value} className="form-select">
										<option value="0">ثبت اولیه</option>
										<option value="2">واگذار شده</option>
										<option value="6">سرحساب</option>
									</select>
								</div>
							</div>}
							{this.state.type === 2 && <div className="row mr-t-5">
								<div className="col-sm-3 text-left">وضعیت <span className="red">*</span> :</div>
								<div className="col-sm-9">
									<select defaultValue={this.state.data.record.status} onChange={e => this.state.data.record.status = e.target.value} className="form-select">
										<option value="0">ثبت اولیه</option>
									</select>
								</div>
							</div>}
							<div className="row mr-t-5">
								<div className="col-sm-12 text-left"><input defaultChecked={this.state.data.record.guarantee} onChange={e => this.state.data.record.guarantee = e.target.checked} type="checkbox" /> ضمانتی</div>
							</div>
						</div>
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
						<button onClick={e => this.save()} className="btn btn-success">ذخیره </button>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.renderForm()
			];

		return contents;
	}
}